import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PageSearch from "../../../../common/components/pageSearch/PageSearch";
import PaginationComponent from "../../../../common/components/pagination/Pagination";
import { constants } from "../../../../common/constants/constants";
import { updateIsLoading } from "../../../../reducerSlices/loaderSlice";
import styles from "./PosAccListing.module.scss";
import { EmptyContainer } from "../../../../common/pages/ordersListing/components/emptyContainer/EmptyContainer";
import { setTab } from "../../../../reducerSlices/selectedTabSlice";
import { resetToastStatus } from "../../../../reducerSlices/toastStatusSlice";
import successToast from "../../../../assets/images/successToast.svg";
import { ToastNotification } from "../../../../common/components/toastNotification/ToastNotification";
import debounce from "lodash/debounce";
import { setPage } from "../../../../reducerSlices/selectedPageSlice";
import callApi from "../../../../utils/api-client";
import { PaginatedResultResponse } from "../../../../types/common";
import {
  PosAccListingProps,
  PosAccListingResponse,
} from "../../../../types/pos";
import PosAccListingCard from "./PosAccListingCard/PosAccListingCard";

function PosAccListing() {
  const selectedTab = useSelector(
    (state: any) => state?.selectedTab?.users_list ?? 0
  );
  const selectedPage = useSelector(
    (state: any) => state?.selectedPage?.usersPageNumber
  );
  const [currentPage, setCurrentPage] = useState(selectedPage);
  const [finalActive, setFinalActive] = useState<PosAccListingProps[]>([]);
  const [searchValue, setSearchValue] = useState("");
  const [listDataCount, setListDataCount] = useState(0);
  const [activeTab, setActiveTab] = useState(selectedTab);
  const myRef = useRef<null | HTMLDivElement>(null);
  const { toastStatus } = useSelector((state: any) => state);
  const [createdToast, setCreatedToast] = useState(constants.defaultToastData);
  const [editedToast, setEditedToast] = useState(constants.defaultToastData);
  const dispatch = useDispatch();

  const handlePagination = (e: React.ChangeEvent<unknown>, page: number) => {
    setCurrentPage(page);
    getPosAccList(page, searchValue);
    dispatch(setPage({ type: "usersPageNumber", index: page }));
  };
  const searchCustomStyles = {
    top: "0px",
  };

  useEffect(() => {
    myRef.current?.scroll({ top: 0, behavior: "smooth" });
  }, [currentPage]);

  useEffect(() => {
    if (toastStatus?.message?.length > 0 && toastStatus?.status === "created") {
      setCreatedToast({
        message: toastStatus?.message,
        status: toastStatus?.status,
      });
      setTimeout(() => {
        dispatch(resetToastStatus());
        setCreatedToast(constants.defaultToastData);
      }, 2000);
    }
  }, [dispatch, toastStatus]);

  useEffect(() => {
    if (toastStatus?.message?.length > 0 && toastStatus?.status === "edited") {
      setEditedToast({
        message: toastStatus?.message,
        status: toastStatus?.status,
      });
      setTimeout(() => {
        dispatch(resetToastStatus());
        setEditedToast(constants.defaultToastData);
      }, 2000);
    }
  }, [dispatch, toastStatus]);

  const handleSearch = (value: string) => {
    setCurrentPage(1);
    setSearchValue(value);
    dispatch(setPage({ type: "usersPageNumber", index: 1 }));
    getUserData(1, value);
  };

  const getPosAccList = async (page: number = 1, searchTerm: string) => {
    dispatch(updateIsLoading(true));
    const response = await callApi<
      PaginatedResultResponse<PosAccListingResponse[]>
    >(
      `admin/pos/paginated?page=${page}&limit=10&offset=${
        (page - 1) * constants.paginationLimitPerPage
      }&search=${searchTerm.length > 0 ? searchTerm : ""}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      "posUserListPaginated"
    );
    dispatch(updateIsLoading(false));
    return response;
  };

  const getUserData = async (currentPage: number, searchTerm?: string) => {
    const usersData = await getPosAccList(
      currentPage,
      searchTerm ? searchTerm : ""
    );
    if (!!usersData) {
      setFinalActive(
        usersData.data.map((item) => ({
          posId: item.pos_id,
          businessSetupId: item.business_setup_id,
          businessName: item.business_name,
          businessEmail: item.business_email,
          createdAt: item.created_at,
          updatedAt: item.updated_at,
        }))
      );
      setListDataCount(usersData.total_count ?? 0);
      return;
    }
    setShowEmptyContainer(true);
    setFinalActive([]);
    setListDataCount(0);
  };

  const debounceSearch = debounce(getUserData, 200);

  useEffect(() => {
    setFinalActive([]);
    debounceSearch(1, "");
  }, [activeTab, currentPage]);

  const [showEmptyContainer, setShowEmptyContainer] = useState(false);
  const TAB_LIST = [{ key: "pos-accounts", value: "POS Accounts" }];
  const selectTab = (index: number) => {
    dispatch(setTab({ type: "users_list", index }));
    setActiveTab(index);
    setCurrentPage(1);
    dispatch(setPage({ type: "usersPageNumber", index: 1 }));
  };
  return (
    <>
      <div className={styles.container}>
        <div className={styles.tabs}>
          <div className={styles.tabsStyle}>
            <div className={styles.tabList}>
              {TAB_LIST.map((tab, index) => (
                <div
                  className={styles.tabListItem}
                  onClick={() => selectTab(index)}
                >
                  <div
                    className={`${styles.label} ${
                      index === activeTab && styles.activeLabel
                    }`}
                  >
                    {tab.value}
                  </div>
                  {activeTab === index && <div className={styles.border} />}
                </div>
              ))}
            </div>
            <div className={styles.hr} />
          </div>
          <div className={`${styles.actions}`}>
            <PageSearch
              handleSearch={handleSearch}
              customStyles={searchCustomStyles}
              customPlaceHolder={`Search by business name`}
              activeTab={activeTab}
            />
          </div>
        </div>
        {!showEmptyContainer ? (
          <div className={styles.tabsContent}>
            <div className={styles.tableHeader}>
              <div className={`${styles.headerColumn1} ${styles.w_40} `}>
                Business Name
              </div>
              <div
                className={`${styles.headerColumn1} ${styles.w_30} ${styles.headerColumn2}`}
              >
                Email ID
              </div>
              <div
                className={`${styles.headerColumn1} ${styles.headerColumn3}`}
              >
                Created At
              </div>
              <div
                className={`${styles.headerColumn1} ${styles.headerColumn4}`}
              >
                Updated At
              </div>
            </div>

            {!showEmptyContainer ? (
              <div className={styles.tabslistContainer}>
                <div className={styles.ordersList} ref={myRef}>
                  {finalActive &&
                    finalActive?.map((p) => (
                      <PosAccListingCard PosAccDetails={p} />
                    ))}
                </div>
                <div className={styles.paginationContainer}>
                  <PaginationComponent
                    count={Math.ceil(
                      listDataCount / constants.paginationLimitPerPage
                    )}
                    page={currentPage}
                    handlePagination={handlePagination}
                    showFirstButton={true}
                    showLastButton={true}
                  />
                </div>
              </div>
            ) : (
              <div className={styles.emptyContainer}>
                <EmptyContainer />
              </div>
            )}
          </div>
        ) : (
          <div className={styles.emptyContainer}>
            <EmptyContainer title={"Woah!"} subText={"No users"} />
          </div>
        )}
      </div>
      {createdToast?.message !== "" ? (
        <ToastNotification
          icon={successToast}
          content={createdToast?.message}
          position={"top-right"}
          autoClose={2000}
        />
      ) : (
        <></>
      )}
      {editedToast?.message !== "" ? (
        <ToastNotification
          icon={successToast}
          content={editedToast?.message}
          position={"top-right"}
          autoClose={2000}
        />
      ) : (
        <></>
      )}
    </>
  );
}

export default PosAccListing;
